import { createSlice, current } from '@reduxjs/toolkit';
import {
	getInspectionList,
	getInspection,
	addNewInspection,
	updateInspection,
	deleteInspection,
} from './thunk';

export const initialState = {
	itemInspectionList: [],
	itemInspection: null,
	isInspectionLoading: false,
	isInspectionSuccess: false,
	inspectionList: [],
	inspectionListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const InspectionSlice = createSlice({
	name: 'Inspection',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getInspectionList.pending, state => {
			state.isLoadingList = true;
			state.isInspectionSuccess = false;
		});

		builder.addCase(getInspectionList.fulfilled, (state, action) => {
			const inspectionList = action.payload || [];
			state.itemInspectionList = inspectionList;
			state.inspectionList = inspectionList;
			state.inspectionListSelect = inspectionList.map(item => ({
				item,
				value: item._id,
				label:
					item.code || item.inspection_code || item.observation || `#${item._id}`,
			}));
			state.isLoadingList = false;
			state.isInspectionSuccess = true;
		});

		builder.addCase(getInspectionList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isInspectionSuccess = false;
		});

		builder.addCase(getInspection.pending, state => {
			state.isInspectionLoading = true;
			state.isInspectionSuccess = false;
		});

		builder.addCase(getInspection.fulfilled, (state, action) => {
			state.itemInspection = action.payload;
			state.isInspectionLoading = false;
			state.isInspectionSuccess = true;
		});

		builder.addCase(getInspection.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isInspectionLoading = false;
			state.isInspectionSuccess = false;
		});

		builder.addCase(addNewInspection.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewInspection.fulfilled, (state, action) => {
			state.itemInspectionList.push(action.payload);
			state.inspectionList.push(action.payload);
			state.inspectionListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label:
					action.payload.code ||
					action.payload.inspection_code ||
					action.payload.observation ||
					`#${action.payload._id}`,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewInspection.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateInspection.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateInspection.fulfilled, (state, action) => {
			state.itemInspectionList = state.itemInspectionList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.inspectionList = state.inspectionList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.inspectionListSelect = state.inspectionListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
						item: action.payload,
						value: action.payload._id,
						label:
							action.payload.code ||
							action.payload.inspection_code ||
							action.payload.observation ||
							`#${action.payload._id}`,
					}
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateInspection.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteInspection.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteInspection.fulfilled, (state, action) => {
			state.itemInspectionList = current(state.itemInspectionList).filter(
				item => item._id !== action.payload._id
			);
			state.inspectionList = current(state.inspectionList).filter(
				item => item._id !== action.payload._id
			);
			state.inspectionListSelect = current(state.inspectionListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteInspection.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});
	},
});

export const { setRequireCloseModal } = InspectionSlice.actions;

export default InspectionSlice.reducer;
